<template>
  <a class="google" :href="href || '/login?provider=google'">
    <div class="img"><img src="@/assets/img/btn_google_light_normal.svg"></div>
    <div class="prompt">{{$t('index.login_prompt_google')}}</div>
  </a>
</template>

<script>
export default {
  props: {
    href: String
  },
};
</script>
